import { useMediaQuery } from '@renderer-ui-library/mui/utils/mediaQuery/useMediaQuery';
import { CustomerMap } from '@renderer-ui-library/organisms';
import { BlockWrapper } from '@renderer-ui-library/scaffolding/BlockWrapper/BlockWrapper';
import { BlockProps } from '../BlockProps';

export const HappyCustomersMapBlock: React.FC<BlockProps> = ({
    locale,
    data,
}) => {
    const { isMobile } = useMediaQuery();

    return (
        <BlockWrapper blockData={data}>
            <CustomerMap locale={locale} mapWidth={isMobile ? 600 : 1180} />
        </BlockWrapper>
    );
};

HappyCustomersMapBlock.displayName = 'HappyCustomersMapBlock';
